module.exports = __webpack_public_path__ + "static/media/furia-identity.e35c0c85.svg";